// import {
//   BriefcaseBusinessIcon,
//   GraduationCapIcon,
//   SchoolIcon,
//   ShieldCheckIcon,
//   UsersRoundIcon,
// } from "lucide-react";
import DestinationFeatureItem from "./DestinationFeatureItem";

// const features = [
//   {
//     icon: <GraduationCapIcon />,
//     text: "Temporary Graduate visa (2–4 years post-study)",
//   },
//   {
//     icon: <BriefcaseBusinessIcon />,
//     text: "Part-time work during studies",
//   },
//   {
//     icon: <ShieldCheckIcon />,
//     text: "High quality of life and safety",
//   },
//   {
//     icon: <SchoolIcon />,
//     text: "Nine universities in global top 100",
//   },
//   {
//     icon: <UsersRoundIcon />,
//     text: "Vibrant international student community",
//   },
// ];

interface FeatureItemProps {
  icon: JSX.Element;
  text: string;
}

interface DestinationContentProps {
  highlights: FeatureItemProps[];
  headline: JSX.Element | string;
  description: string;
  destination: string;
}

const DestinationContent: React.FC<DestinationContentProps> = ({
  highlights,
  headline,
  description,
  destination,
}) => {
  return (
    <div className="flex-1 pr-8">
      <div className="mb-6">
        <h4 className="text-3xl font-light text-gray-900 leading-tight mb-4">
          {headline}
        </h4>
      </div>

      <div className="mb-8">
        <p className="text-gray-600 text-base leading-relaxed">{description}</p>
      </div>

      <div className="mb-6">
        <p className="uppercase font-light text-black-31 mb-4">
          Why pick <span>{destination}</span>?
        </p>
      </div>

      <div>
        {highlights.map((feature, index) => (
          <DestinationFeatureItem
            key={index}
            icon={feature.icon}
            text={feature.text}
          />
        ))}
      </div>
    </div>
  );
};

export default DestinationContent;
